import axios from 'axios';

const API = axios.create({ baseURL: '' }); // en local mettre l'url http://localhost:4000 mais pas sur le prod

export default API;
